import { useState } from "react";
import {
  Box,
  Flex,
  Spinner,
  Text,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import Card from "components/card/Card";
import BarChart from "components/charts/BarChart";
import CustomFilter from "./CustomFilter";
import { barChartOptionsConsumption } from "variables/charts";
import { useSell } from "hooks/SellHook";
import { useQuery } from "react-query";

export default function SellClientGraphic(props: { [x: string]: any }) {
  const { ...rest } = props;
  const [filter, setFilter] = useState<number>(7);
  const theme = useColorMode();
  const themeSelect = theme.colorMode;

  const { findTopSellesGraphicClients } = useSell();
  const { data, isLoading, error } = useQuery(
    ["findTopSellesGraphicClients", filter],
    () =>
      findTopSellesGraphicClients({
        dias: filter,
        prioridade: "valor_total",
      }),
    {
      retry: false,
    }
  );

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const textColorGraphic = useColorModeValue("gray", "white");	

  return (
    <Card
      gridRowStart={{ base: 1, md: 1, lg: 1 }}
      gridRowEnd={{ base: 30, md: 30, lg: 30 }}
      alignItems="center"
      flexDirection="column"
      w={{ base: "150%", md: "100%", lg: "100%" }}
      key={data?.VENDAS.NOMES[0] + themeSelect}
      {...rest}
    >
      <Flex align="center" w="100%" px="15px" py="10px">
        <Text
          me="auto"
          color={textColor}
          fontSize="xl"
          fontWeight="700"
          lineHeight="100%"
        >
          Valor de vendas
        </Text>
        <CustomFilter onFilterSelected={(data: any) => setFilter(data)} />
      </Flex>

      <Box h="100%" mt="auto" w="100%">
        {isLoading ? (
          <Box alignItems="center" justifyContent="center" display="flex">
            <Spinner w="100px" h="100px" />
          </Box>
        ) : error ? (
          <Flex
            justify={"center"}
            align={"center"}
            width={"100%"}
            height={"100%"}
          >
            <Text
              color="red.500"
              fontWeight="bold"
              fontSize="xl"
              textAlign="center"
            >
              {String(error)}
            </Text>
          </Flex>
        ) : data.VENDAS.VALORES.length === 0 ? (
          <Flex
            justify={"center"}
            align={"center"}
            width={"100%"}
            height={"100%"}
          >
            <Text
              fontWeight="bold"
              fontSize="xl"
              textAlign="center"
            >
              Nenhum registro encontrado
            </Text>
          </Flex>
        ) : (
          <BarChart
						key={"valores_venda" + data?.VENDAS.VALORES[0]}
            chartData={[{ name: "Valores", data: data?.VENDAS.VALORES }]}
            chartOptions={{
              ...barChartOptionsConsumption,
              theme: {
                mode: themeSelect,
              },
              dataLabels: {
                enabled: true,
                formatter: (value: number) =>
                  value.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  }),
                style: {
                  fontSize: "14px",
                  fontFamily: "Helvetica, Arial, sans-serif",
                  colors: [textColorGraphic],
                },
              },
              xaxis: {
                categories: data?.VENDAS.NOMES,
                labels: {
                  formatter: (value: number) => {
                    if (value >= 1_000_000) {
                      return value / 1_000_000 + "M";
                    } else if (value >= 1_000) {
                      return value / 1_000 + "K";
                    } else {
                      return value;
                    }
                  },
                  style: {
                    colors: "#A3AED0",
                    fontSize: "12px",
                    fontWeight: "500",
                    padding: "4px",
                  },
                  axisBorder: {
                    show: false,
                  },
                  axisTicks: {
                    show: false,
                  },
                },
              },
            }}
          />
        )}
      </Box>
    </Card>
  );
}
